import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AlertifyService } from 'src/app/services/alertify.service';
import { OrdenCompraService } from 'src/app/services/orden-compra.service';


import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {MatDatepicker} from '@angular/material/datepicker';


// Depending on whether rollup is used, moment needs to be imported differently.
// Since Moment.js doesn't have a default export, we normally need to import using the `* as`
// syntax. However, rollup creates a synthetic default module and we thus need to import it using
// the `default as` syntax.
import * as _moment from 'moment';
// tslint:disable-next-line:no-duplicate-imports
import {default as _rollupMoment, Moment} from 'moment';

const moment = _rollupMoment || _moment;

// See the Moment.js docs for the meaning of these formats:
// https://momentjs.com/docs/#/displaying/format/
export const MY_FORMATS = {
  parse: {
    dateInput: 'MM/YYYY',
  },
  display: {
    dateInput: 'MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};


@Component({
  selector: 'app-create-edit-orden-compra',
  templateUrl: './create-edit-orden-compra.component.html',
  styleUrls: ['./create-edit-orden-compra.component.scss'],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ],
})
export class CreateEditOrdenCompraComponent implements OnInit {
  registerForm: UntypedFormGroup;
  public isForEdit = false;
  public dataInput: any;
  public tituloTxt='Crear Orden de compra?'
  public lstDisciplinas: any;
  public lstClubes: any;
  date = new UntypedFormControl(moment());

  constructor(
    public ordenCompraSvc: OrdenCompraService,
    private alertify: AlertifyService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<CreateEditOrdenCompraComponent>
  ) {
    this.dataInput = data;
    console.log('los datos de ingreso son: ', data);
    if (data != null) {
      this.isForEdit = true;
      this.tituloTxt='Editar orden de compra'
    }
  }

  ngOnInit(): void {

  this.inicarFormulario();

  }
inicarFormulario(){
  this.registerForm = new UntypedFormGroup({
    id: new UntypedFormControl(''),
  //  fechaCaducidad: new FormControl(moment(), Validators.required),
  });
  this.registerForm.get('id')?.setValue('00000000-0000-0000-0000-000000000000');
 // this.registerForm.get('fechaCaducidad')?.setValue('');

  if (this.isForEdit) {
    this.registerForm.get('id')?.setValue(this.dataInput.id);
 //   this.registerForm.get('fechaCaducidad')?.setValue(this.dataInput.fechaCaducidad);
  }
}

chosenYearHandler(normalizedYear: Moment) {
  const ctrlValue = this.date.value;
  ctrlValue.year(normalizedYear.year());
  this.date.setValue(ctrlValue);
}

chosenMonthHandler(normalizedMonth: Moment, datepicker: MatDatepicker<Moment>) {
  const ctrlValue = this.date.value;
  ctrlValue.month(normalizedMonth.month());
  this.date.setValue(ctrlValue);
  this.registerForm.get('fechaCaducidad')?.setValue(this.date.value.toDate());
  datepicker.close();
}

  guardar() {
    console.log('guardar OC');
    console.log(this.registerForm.value);
    if (this.isForEdit) {
      //aqui mando a editar
      this.ordenCompraSvc
        .editOrdenCompra(this.registerForm.value)
        .subscribe((res) => {
          console.log('resultado Editar: ', res);
          if (res) {
            this.alertify.success('Orden de compra actualizada');
            this.dialogRef.close();
          } else {
            this.alertify.error('La orden de compra no se ha podido actualizar');
          }
        });
    } else {
      //aqui mando a crearlo

        //https://stackoverflow.com/questions/3232701/using-json-to-serialize-deserialize-timespan
    //    this.registerForm.get('horaInicio')?.setValue(this.registerForm.value.horaInicio+':00');
    //    this.registerForm.get('horaFin')?.setValue(this.registerForm.value.horaFin+':00')
      this.ordenCompraSvc
        .addOrdenCompra(this.registerForm.value)
        .subscribe((res) => {
          console.log('resultado crear: ', res);
          if (res) {
            this.alertify.success('Orden de compra creada');
            this.dialogRef.close();
          } else {
            this.alertify.error(
              'La orden de compra no se ha podido crear'
            );
          }
        });
    } 
  }


  estado(){

    console.log(this.registerForm.value)
  }


}
